import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText, Typography } from '@mui/material';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import RestoreRoundedIcon from '@mui/icons-material/RestoreRounded';
export const ENROLLMENT_WELCOME_SESSION_KEY = 'stacktrack-enrollment-welcome';

/**
 * Shown when a student logs in and roster profiles were auto-linked or restored.
 */
export default function EnrollmentWelcomeDialog({
  open,
  enrollment,
  onContinue
}) {
  const batches = Array.isArray(enrollment?.batches) ? enrollment.batches : [];
  const linkedBy = enrollment?.linkedBy || null;
  const restored = enrollment?.restored === true;
  return <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1
    }}>
        {restored ? <RestoreRoundedIcon color="primary" /> : <SchoolRoundedIcon color="primary" />}
        {restored ? 'Welcome back' : 'Welcome to StackTrack'}
      </DialogTitle>
      <DialogContent>
        {restored ? <Typography variant="body1" sx={{
        mb: 2
      }}>
            Your existing StackTrack profile has been restored.
          </Typography> : <Typography variant="body1" sx={{
        mb: 2
      }}>
            You have been enrolled in:
          </Typography>}

        {batches.length > 0 ? <>
            {restored ? <Typography variant="body2" sx={{
          mb: 1
        }}>
                Batches:
              </Typography> : null}
            <List dense disablePadding sx={{
          mb: 2
        }}>
              {batches.map(batch => <ListItem key={batch.id} disableGutters>
                  <ListItemText primary={batch.name || batch.code || 'Batch'} secondary={batch.code && batch.name !== batch.code ? batch.code : null} />
                </ListItem>)}
            </List>
          </> : <Typography variant="body2" color="text.secondary" sx={{
        mb: 2
      }}>
            Your faculty roster has been linked to your account.
          </Typography>}

        {restored ? <Typography variant="body2" color="text.secondary" sx={{
        mb: 1
      }}>
            Coding history, assignments, and analytics have been preserved.
          </Typography> : null}

        {linkedBy ? <Typography variant="body2" color="text.secondary">
            Linked by: {linkedBy}
          </Typography> : null}
      </DialogContent>
      <DialogActions sx={{
      px: 3,
      pb: 2
    }}>
        <Button variant="contained" onClick={onContinue} sx={{
        textTransform: 'none'
      }}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>;
}
export function EnrollmentWelcomeRoot() {
  const [open, setOpen] = React.useState(false);
  const [enrollment, setEnrollment] = React.useState(null);
  React.useEffect(() => {
    try {
      const raw = sessionStorage.getItem(ENROLLMENT_WELCOME_SESSION_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed?.newlyClaimed) {
        setEnrollment(parsed);
        setOpen(true);
        sessionStorage.removeItem(ENROLLMENT_WELCOME_SESSION_KEY);
      }
    } catch {
      /* ignore */
    }
  }, []);
  if (!enrollment) return null;
  return <EnrollmentWelcomeDialog open={open} enrollment={enrollment} onContinue={() => setOpen(false)} />;
}
